
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Nein. Man kann aber mit der sogenannten Imagery Rehearsal Therapy im Wachzustand trainieren, den Albtraum ins Positive zu kehren: `}<M mdxType="M">{`Bei einem Sturz ins Bodenlose baut man zum Beispiel einen Fallschirm in den Pyjama ein,`}</M>{` oder man benutzt die Arme als Flügel. Das neue Ende des Traums spielt man dann täglich während zehn Minuten zwei Wochen lang durch. Rund 70 Prozent der Betroffenen träumen danach besser.`}</p>
    <Tracking label='content25' mdxType="Tracking" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;